import { Result } from 'antd'
import React from 'react'
import './index.less'

function NoConfiguration() {
	return (
		<>
			<span className="non-clickable-overlay" />
			<Result
				title="No Configuration found"
				subTitle={"Sorry, You haven't configure site integration yet. Please, contact our support for details."}
			/>
		</>
	)
}

export default NoConfiguration
